<div class="profile-container">
  <div class="">
    <div class="profile-content">

      <div class="personal-details">

        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">






            <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i
                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
            <div class="filter-icon">
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
            </div>

          </div>
        </div>

        <table class="table table-striped">
          <thead>
            <tr>

              <th style="width: 25%;">Priority Status</th>
              <th style="width: 25%;">Time In Hrs</th>
              <th style="width: 30%;">Description</th>
              <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

            </tr>
          </thead>
        </table>
        <div *ngIf="!isLoading">
          <div class="data-view" *ngFor="let item of dataList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                        }  ;let i = index">

            <p style="width: 25%;">{{item.priorityStatus}}</p>
            <p style="width: 25%;">{{item.timeInHrs}}</p>
            <p style="width: 30%;">{{item.description}}</p>
            <p class="action-buttons" style="width: 20%;padding-left: 25px;justify-content: center;">
              <i *ngIf="actionControls.isView" (click)="getById(item.id, 'view')" title="View" class="bi bi-eye"
                data-toggle="modal" data-target="#exampleModalView"></i>
              <i *ngIf="actionControls.isModify" (click)="getById(item.id, 'edit')" title="Edit" class="bi bi-pencil"
                data-toggle="modal" data-target="#exampleModalEdit"></i>
              <i *ngIf="actionControls.isDelete" (click)="selectDelete(item.id,item)" title="Delete" class="bi bi-trash"
                data-toggle="modal" data-target="#deleteModal"></i>
            </p>
          </div>
        </div>


        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>

        <div class="loader" *ngIf="!isLoading && dataList.length == 0">
          <div class="no-data">
            <img src="assets/no-data-6.png" alt="">
            <p>no data found</p>
          </div>

        </div>

        <div class="paginator">
          <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
            [totalRecords]="count" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
        </div>


      </div>

    </div>
  </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'generic.add' | translate }}
          <span data-dismiss="modal">
            <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Priority Status <span class="required">*</span></label>
                <select formControlName="priorityStatus" class="form-control">
                  <option value="">Select Status</option>
                  <option value="HIGH">HIGH</option>
                  <option value="MEDIUM">MEDIUM</option>
                  <option value="LOW">LOW</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Time In Hrs <span class="required">*</span></label>
                <input formControlName="timeInHrs" type="number" class="form-control">
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30"
                  rows="3"></textarea>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="formReset()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="addRecord()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>




<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">View Details
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">

        <div *ngFor="let item of singleRecord">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Priority Status</label>
                <input type="text" value="{{item.priorityStatus}}" class="form-control" readonly>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Time In Hrs</label>
                <input type="text" value="{{item.timeInHrs}}" class="form-control" readonly>
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" value="{{item.description}}" name="" id="" cols="30" rows="3"
                  readonly></textarea>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButtonView" class="btn btn-secondary" data-dismiss="modal">{{
            'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="exampleModalEdit" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Details
          <span data-dismiss="modal">
            <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="editForm">
          <div class="row">
            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Priority Status <span class="required">*</span></label>
                <select formControlName="priorityStatus" class="form-control">
                  <option value="">Select Status</option>
                  <option value="HIGH">HIGH</option>
                  <option value="MEDIUM">MEDIUM</option>
                  <option value="LOW">LOW</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Time In Hrs <span class="required">*</span></label>
                <input formControlName="timeInHrs" type="number" class="form-control">
              </div>
            </div>

            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Description</label>
                <textarea class="form-control" formControlName="description" name="" id="" cols="30"
                  rows="3"></textarea>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButtonEdit" (click)="formReset()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="updateRecord()" class="btn btn-primary">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton" (click)="closeModal()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteRecord()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>